import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnModel, ColumnType } from '@ipensii/shared/domain-shared';
import { IndexedMap, ObjectUtils } from '@ipensii/shared/util-shared';
import { FormatDateTimePipe } from '../date/formatDateTime.pipe';
import { FormatDatePipe } from '../date/formatDate.pipe';
import { EmptyPipe } from '../empty/empty.pipe';

@Component({
  selector: 'ip-shared-list-column',
  standalone: true,
  imports: [CommonModule, FormatDateTimePipe, FormatDatePipe, EmptyPipe],
  templateUrl: 'list-column.component.html',
})
export class ListColumnComponent<D> {
  @Input({ required: true }) column!: ColumnModel;
  @Input({ required: true }) data!: D;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() translate?: IndexedMap<any, string>;
  @HostBinding('class') readonly hostClasses = 'contents';
  protected readonly ObjectUtils = ObjectUtils;
  protected readonly ColumnType = ColumnType;
}
